import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "gota-kanal-app" }

import Toast from "@components/Toast/Toast.vue";
import { useToast } from "@components/Toast/toast-service";
import SiteHeader from "@shared/Layout/SiteHeader/SiteHeader.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

const { toasts, removeToast } = useToast();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SiteHeader),
    _createVNode(_component_router_view),
    _createVNode(_TransitionGroup, {
      name: "toast",
      tag: "div",
      class: "toast-stack",
      "aria-live": "polite",
      "aria-atomic": "true",
      "aria-label": "Notifications"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (toast) => {
          return (_openBlock(), _createBlock(Toast, {
            key: toast.id,
            toast: toast,
            onClose: ($event: any) => (_unref(removeToast)(toast.id))
          }, null, 8 /* PROPS */, ["toast", "onClose"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})